
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/billing",
      function () {
        return require("private-next-pages/dashboard/billing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/billing"])
      });
    }
  